// extracted by mini-css-extract-plugin
module.exports = {"popups-root":"_3_nc1","popupsRoot":"_3_nc1","popups-wrapper":"_1NYRG","popupsWrapper":"_1NYRG"};